module.exports = "\n  <div>\n    <slot />\n  </div>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-flickity/src/flickity.vue
// module id = 135
// module chunks = 2 4 5 13